import React, { useEffect } from "react";
import { IStoragePathItemData } from "../../../../dataingestion/types/IStoragePathItemData";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { searchLookupValueByCode } from "../../../../lookup/services/LookupHelpers";
import { AGREEMENT_ATTACHMENT_TYPE_LOOKUP } from "../../../../lookup/Consts";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";

interface IDraftAgreementsAttachmentsReviewProps {
    attachedFiles: IStoragePathItemData[];
    lookupValues: ILookupDictionary;
    draftAgreementMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;
}

const DraftAgreementsAttachmentsReview: React.FC<IDraftAgreementsAttachmentsReviewProps> = ({
    attachedFiles,
    lookupValues,
    draftAgreementMaintenanceGeneralDataViewData
}) => {
    const [viewData, setViewData] = React.useState([])

    useEffect(() => {
        if (draftAgreementMaintenanceGeneralDataViewData?.fields) {
            const visibleFields = draftAgreementMaintenanceGeneralDataViewData.fields.filter(field => !field.hidden);
            let newViewData = [];
            visibleFields.forEach(item => {
                newViewData[item.name] = item.data;
            });
            setViewData(newViewData);
        }
    
    }, [draftAgreementMaintenanceGeneralDataViewData]);

    const formatAttachmentType = (code: string): string => {
        return searchLookupValueByCode(AGREEMENT_ATTACHMENT_TYPE_LOOKUP, lookupValues, code) || code;
    };

    return <>
        <div className="headerContainer">
            <div className="row fullWidth">
                <div
                    className={["headerSection", "activeSection"].join(" ")}
                    key={'Attachments'}
                    data-testid={'Attachments' + "-section"}
                >
                    {viewData['draftAgreementReviewAttachments']}
                </div>
                <>
                    {attachedFiles && attachedFiles.map((file, index) => {
                        return <div className="flexRow fullWidth">
                                    <div className="flexRow fullWidth">
                                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                <div className="flexRow" style={{gap: '10px',alignItems: 'baseline'}}>
                                                    <label >{viewData['name'] || 'Name:'}</label>
                                                    {file.name}
                                                </div>
                                            </div>
                                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                                    <div className="flexRow" style={{gap: '10px',alignItems: 'baseline'}}>
                                                        <label >{viewData['attachmentType'] || 'Attachment Type:'}</label>
                                                        {formatAttachmentType(file.attachmentTypeCode)}
                                                    </div>
                                            </div>

                                    </div>
                                </div>

                    })}
                </>
            </div>
        </div>
    </>
}

export default DraftAgreementsAttachmentsReview;